import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    page: {
        padding: '20 20 40 20',
        fontSize: 6, // Reduced font size for table content
        fontFamily: 'Helvetica',
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    header: {
        marginBottom: 10,
        /*  borderBottom: '1px solid #34C6F1',
         borderBottomColor: '#34C6F1', // Updated color */
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    headerText: {
        fontSize: 12,
        fontWeight: 'bold',
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 10,
        textTransform: 'uppercase',
    },
    section: {
        marginBottom: 10,
    },
    text: {
        marginBottom: 8,
        textAlign: 'justify',
    },
    bold: {
        fontFamily: 'Helvetica-Bold',
    },
    footer: {
        position: 'absolute',
        bottom: 10,
        left: 40,
        right: 40,
        textAlign: 'center',
        fontSize: 8,
        color: 'grey',
        borderTopWidth: 1,
        borderTopColor: '#34C6F1', // Updated color
        paddingTop: 0,
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 8,
        bottom: 30,
        right: 40,
        textAlign: 'right',
        color: 'grey',
    },
    // Table Styles
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 3,
        borderColor: '#34C6F1',
        borderRadius: 10,
        overflow: 'hidden',
        marginBottom: 5,
    },
    tableRow: {
        margin: 'auto',
        flexDirection: 'row',
    },
    tableCol: {
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#34C6F1', // Using HEX to ensure correct color
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: "1px",
    },
    tableCellLabel: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 7,
        color: '#333',
    },
    tableCellValue: {
        fontSize: 7,
        fontFamily: 'Helvetica',
    },
    tableTitle: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        color: '#34C6F1',
        marginBottom: 0,
        marginLeft: 5,
        marginTop: 8,
    },
    // Logo & Background
    logo: {
        width: 100,
        height: 'auto',
    },
    backgroundImage: {
        position: 'absolute',
        top: '35%', // Adjusted for better centering
        left: '15%', // Adjusted for better centering
        width: '70%', // Increased width
        height: 'auto',
        opacity: 0.1,
        transform: 'rotate(-45deg)',
        zIndex: -1,
    },
    // Signature Block Styles
    signatureBlock: {
        width: '48%',
        borderWidth: 1,
        borderColor: '#34C6F1',
        borderRadius: 10,
        padding: 5,
        // height: 80, // Removed fixed height to allow content to fit
    },
    signatureTitle: {
        fontSize: 8,
        textAlign: 'center',
        fontFamily: 'Helvetica-Bold',
        marginBottom: 25,
    },
    signatureNameContainer: {
        marginTop: 40,
        backgroundColor: 'rgba(31, 221, 143, 0.3)',
        borderRadius: 5,
        padding: 10,
        height: 60, // Increased height for signature space
        justifyContent: 'space-between', // Separate content
    },
    signatureText: {
        fontSize: 8,
        textAlign: 'center',
        fontFamily: 'Helvetica',
    },
    signatureSubtext: {
        fontSize: 8,
        textAlign: 'center',
        marginTop: 2,
        fontFamily: 'Helvetica',
    },
});
